'use strict';

module.exports = /*@ngInject*/
function(
    AnthroConfig,
    InterceptorService
) {
    return {
        scope: {
            includePath: '@includeJsp'
        },
        link: function(scope, element, attrs) {
            var expiryTime = attrs.expiryTime || AnthroConfig.cache.defaultJSPExpiryTime;

            return InterceptorService.cachedGet(scope.includePath, '', {
                compress: true,
                expiryTime: expiryTime
            }).then(function onRes(res) {
                angular.element(element).append(res);
            });
        }
    };
};
